import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { cashboxApi } from '../../../lib/cashboxApi.js';

const EVENT_LABEL: Record<string, string> = {
  create: 'Создание',
  update: 'Изменение',
  soft_delete: 'Удаление',
  restore: 'Восстановление',
  hard_delete: 'Жёсткое удаление',
  open_shift: 'Открытие смены',
  close_shift: 'Закрытие смены',
  import: 'Импорт',
  settings_update: 'Настройки',
  amo_resync: 'Синхр. AMO',
};

const EVENT_BADGE: Record<string, string> = {
  create: 'green',
  update: 'blue',
  soft_delete: 'yellow',
  restore: 'teal',
  hard_delete: 'red',
  open_shift: 'green',
  close_shift: 'gray',
  import: 'blue',
  settings_update: 'purple',
  amo_resync: 'teal',
};

export function CashboxAudit() {
  const [filterEvent, setFilterEvent] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const params: Record<string, string | undefined> = {};
  if (filterEvent) params['event'] = filterEvent;
  if (from) params['from'] = from;
  if (to) params['to'] = to;

  const { data, isLoading } = useQuery({
    queryKey: ['cashbox', 'audit', params],
    queryFn: () => cashboxApi.getAudit(params),
  });

  const entries = data?.items ?? [];
  const total = data?.total ?? 0;

  return (
    <div>
      {/* Filters */}
      <div className="toolbar" style={{ marginBottom: 12, gap: 8 }}>
        <select
          className="input-admin"
          value={filterEvent}
          onChange={(e) => setFilterEvent(e.target.value)}
          style={{ width: 180 }}
          data-testid="audit-filter-event"
        >
          <option value="">Все события</option>
          {Object.entries(EVENT_LABEL).map(([v, l]) => (
            <option key={v} value={v}>{l}</option>
          ))}
        </select>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>С</label>
          <input className="input-admin" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>По</label>
          <input className="input-admin" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
      </div>

      <div className="panel">
        <div className="panel-head">
          <p className="panel-title">
            Журнал аудита
            {total > 0 && <span className="muted"> ({total})</span>}
          </p>
        </div>

        {isLoading && (
          <p style={{ padding: 32, textAlign: 'center', color: 'var(--mnp-fg-3)' }}>Загрузка…</p>
        )}

        {!isLoading && (
          <table className="data" data-testid="audit-table">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Событие</th>
                <th>Тип объекта</th>
                <th>Объект</th>
                <th>Поле</th>
                <th>Источник</th>
                <th>Актор</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ padding: 40, textAlign: 'center', color: 'var(--mnp-fg-3)' }}>
                    Событий пока нет
                  </td>
                </tr>
              )}
              {entries.map((e) => (
                <tr key={e.id}>
                  <td className="muted" style={{ fontSize: 11 }}>
                    {new Date(e.createdAt).toLocaleString('ru-RU')}
                  </td>
                  <td>
                    <span className={`badge-a ${EVENT_BADGE[e.event] ?? 'gray'}`}>
                      {EVENT_LABEL[e.event] ?? e.event}
                    </span>
                  </td>
                  <td className="muted">{e.entityType}</td>
                  <td className="mono" style={{ fontSize: 11 }}>{e.entityId}</td>
                  <td className="muted">{e.field ?? '—'}</td>
                  <td>
                    <span className="badge-a gray">{e.source}</span>
                  </td>
                  <td className="mono" style={{ fontSize: 11 }}>{e.actorChatId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
